import React from 'react';
import { FormControl, InputLabel, Select, MenuItem, Box } from '@mui/material';
import { useAppDispatch, useAppSelector } from '../../../../../../app/store';
import { updateCaseManage } from '../../../../../../services/CaseManagementService';

const coverageOptions = [
  'Not Supported',
  'Clinical Records',
  'History and Physical',
  'Imaging Report',
  'Pathology',
  'Physical Therapy Notes',
  'Psychological Evaluation',
  'Other'
];

const Dx3CoverageStatusField: React.FC = () => {
  const dispatch = useAppDispatch();
  const { currentCase } = useAppSelector(state => state.caseManage);

  const diagnosis3Value = currentCase?.codingDetails?.diagnosisCodes?.diagnosis3 || '';
  const isDiagnosisEmpty = !diagnosis3Value.trim();
  const coverageValue = isDiagnosisEmpty ? 'Not Supported' : (currentCase?.codingDetails?.diagnosisCodes?.dx3CoverageStatus || '');

  const handleCoverageChange = (value: string) => {
    if (!currentCase?.codingDetails?.diagnosisCodes) return;
    
    const updatedDiagnosisCodes = {
      ...currentCase.codingDetails.diagnosisCodes,
      dx3CoverageStatus: value
    };
    
    dispatch(updateCaseManage({
      codingDetails: {
        ...currentCase.codingDetails,
        diagnosisCodes: updatedDiagnosisCodes
      }
    }));
  };

  return (
    <Box sx={{ flex: 1 }}>
      <FormControl size="small" fullWidth>
        <InputLabel>Dx3 Coverage Status</InputLabel>
        <Select
          value={coverageValue}
          onChange={(e) => handleCoverageChange(e.target.value)}
          label="Dx3 Coverage Status"
          disabled={isDiagnosisEmpty}
        >
          <MenuItem value="">Select Status</MenuItem>
          {coverageOptions.map((option) => (
            <MenuItem key={option} value={option}>
              {option}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Box>
  );
};

export default Dx3CoverageStatusField;
